import * as Styled from './Label.styled';
import type { LabelProps } from './Label.types';

/* as={as as 'label'} is the only way TS will allow the htmlFor prop to be possibly defined */
export const Label = ({
  required = false,
  children,
  as = 'label',
  ...rest
}: LabelProps) => {
  return (
    <Styled.Label as={as as 'label'} {...rest}>
      {children}
      {required && (
        <Styled.RequiredIndicator aria-hidden="true">
          *
        </Styled.RequiredIndicator>
      )}
    </Styled.Label>
  );
};

export default Label;
